import { useI18n } from "@core/i18n/i18n";
import { TextInput } from "@ui/components/inputs/text-input";
import { FormField } from "@ui/pages/prospect/components/form-field";
import { PtInfoFormData } from "@ui/pages/prospect/pt-info-form-data";
import { REGEX_EMAIL } from "@utils/regex-utils";
import React from "react";
import { Control, Controller } from "react-hook-form";

interface EmailControllerProps {
	control?: Control<PtInfoFormData>;
	isRequired?: boolean;
}

export function EmailController({ control, isRequired = false }: EmailControllerProps): JSX.Element {
	const { format } = useI18n();
	return (
		<Controller
			name="email"
			control={control}
			rules={{
				required: isRequired ? format("global.form.field.requiredError") : undefined,
				pattern: {
					value: REGEX_EMAIL,
					message: format("demoRequest.emailField.formatError"),
				},
			}}
			render={({ field, fieldState }) => (
				<FormField
					title={
						isRequired ? format("demoRequest.emailField.title") : format("inviteYourPt.form.ptSection.email.title")
					}
					errorMessage={fieldState.error?.message}
				>
					<TextInput
						{...field}
						placeholder={format("demoRequest.emailField.placeholder")}
						error={fieldState.invalid}
						inputMode="text"
						autoCorrect="off"
						autoCapitalize="none"
					/>
				</FormField>
			)}
		/>
	);
}
